import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { TemplatesRoutes } from '../../../routes';

export const TemplatesLayout = () => <SwitchRoute routes={TemplatesRoutes} />;
